import React from "react";
import { withTranslation } from "react-i18next";
import { Grid, Typography } from "@mui/material";
import moment from "moment";
import PropTypes from "prop-types";

import DateField from "Components/Common/DatePicker";
import InputFieldText from "Components/Common/InputFieldText";

const FireSafetyCertificateApproval = ({ formik, t }) => {
  const {
    values: {
      fireSafetyCertificate: { dateOfIssue },
    },
  } = formik;

  return (
    <Grid container rowSpacing={1} columnSpacing={2} sx={{ pl: 1 }}>
      <Grid item xs={12}>
        <Typography className="mb-3" lineHeight={1} variant="h6">
          {t("Fire Safety Certificate Approval") +
            " " +
            "(" +
            t("Existing") +
            ")"}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <InputFieldText
          label={t("FSCA No.") + "*"}
          name="fireSafetyCertificate.approvalNumber"
          formik={formik}
          placeholder="Enter FSCA No."
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <DateField
          label={t("Date of Issuance") + "*"}
          name="fireSafetyCertificate.dateOfIssue"
          formik={formik}
          views={["day", "month", "year"]}
          format="DD-MM-YYYY"
          disableFuture
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <DateField
          label={t("Due Date") + "*"}
          name="fireSafetyCertificate.dueDate"
          formik={formik}
          views={["day", "month", "year"]}
          format="DD-MM-YYYY"
          minDate={moment(dateOfIssue).add(1, "days")}
        />
      </Grid>
    </Grid>
  );
};

FireSafetyCertificateApproval.propTypes = {
  formik: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(FireSafetyCertificateApproval);
